import "./Footer.scss";
import Logo from "../../assets/images/logo.png";
import FooterDecoration from "../../assets/images/footer-decoration.png";

import ButtonOutline from "../../components/shared/ButtonOutline";

import { ReactComponent as TelegramIcon } from "../../assets/icons/Telegram.svg";
import { ReactComponent as XLogo } from "../../assets/icons/XLogo.svg";
import { ReactComponent as GitbookIcon } from "../../assets/icons/Gitbook.svg";
import { ReactComponent as GithubIcon } from "../../assets/icons/Github.svg";
import { ReactComponent as DexToolsIcon } from "../../assets/icons/DexTools.svg";
import { ReactComponent as DexscreenerIcon } from "../../assets/icons/Dexscreener.svg";

import GridImg from "../../assets/images/Grid.svg";

export default function Footer() {
	return (
		<div className="footer">
			<img
				className="decoration footer-grid-bg"
				src={GridImg}
				alt="Grid"
			/>
			<div className="footer-decoration">
				<img
					className="footer-decoration-left"
					src={FooterDecoration}
					alt="footer-decoration"
				/>
				<img
					className="footer-decoration-right"
					src={FooterDecoration}
					alt="footer-decoration"
				/>
			</div>

			<div className="footer-content-wrapper content-wrapper-lg">
				<div className="footer-content">
					<div className="footer-about">
						<img className="footer-logo" src={Logo} alt="logo" />
						<div className="footer-about-text">
							<h6 className="footer-about-title">AurAi</h6>
							<p className="footer-about-desc">
								Copyright © 2024 - 2025 AurAi®. All rights
								reserved.
							</p>
						</div>
					</div>

					<ul className="footer-socials">
						<li>
							<ButtonOutline
								className="social-btn"
								href="https://t.me/UseAurAI"
							>
								<TelegramIcon className="social-btn-icon" />
								Telegram
							</ButtonOutline>
						</li>
						<li>
							<ButtonOutline
								className="social-btn"
								href="https://x.com/meetaurai"
							>
								<XLogo className="social-btn-icon" />X Platform
							</ButtonOutline>
						</li>

						<li>
							<ButtonOutline className="social-btn">
								<GithubIcon className="social-btn-icon" />
								GitHub
							</ButtonOutline>
						</li>
						<li>
							<ButtonOutline className="social-btn">
								<DexscreenerIcon className="social-btn-icon" />
								Dexscreener
							</ButtonOutline>
						</li>
						<li>
							<ButtonOutline
								className="social-btn"
								href="https://aur-ai.gitbook.io/aurai"
							>
								<GitbookIcon className="social-btn-icon" />
								GitBook
							</ButtonOutline>
						</li>
						<li>
							<ButtonOutline className="social-btn">
								<DexToolsIcon className="social-btn-icon" />
								DEXTools
							</ButtonOutline>
						</li>
					</ul>
				</div>

				<div className="footer-mobile-copyright">
					© 2024 - 2025 AurAi®. All rights reserved.
				</div>
			</div>
		</div>
	);
}
